"use client";

import { useEffect } from "react";
import Script from "next/script";
import { AppConfig } from "~/utils/AppConfig";

const UsersnapScript = () => {
    useEffect(() => {
        window.onUsersnapLoad = function(api) {
            api.init();
        };
    }, []);

    if (AppConfig.isProduction) {
        return null;
    }

    const scriptUrl = "https://widget.usersnap.com/global/load/b0f2da02-98f0-46fb-93ac-cf1bc0fde99f?onload=onUsersnapLoad";
    const scriptId = "usersnap-snippet";

    return <Script src={scriptUrl} id={scriptId} type="text/javascript" strategy="lazyOnload"/>;
};

export default UsersnapScript;